__turbopack_context__.v({
  "backdrop": "modal-module-scss-module__zxRfSG__backdrop",
  "content": "modal-module-scss-module__zxRfSG__content",
  "dialog": "modal-module-scss-module__zxRfSG__dialog",
  "modal": "modal-module-scss-module__zxRfSG__modal",
});
